var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLivingRom = function SvgLivingRom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.29 19.59h1.405v2.353H21.29zM4.067 13.24l.93-2.946 1.341.424-.929 2.945zM17.676 10.717l1.341-.423.93 2.945-1.342.424z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "m12 .058-.469 2.289L12 8.079l8.912-6.63V.058z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M12 8.08V.057H3.088v8.009z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12 4.798-.469 3.83.469 2.581h8.912V1.45l-6.495 4.824z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m9.518 3.284-6.43 4.783v3.142H12v-6.41zM1.305 19.59H2.71v2.353H1.305z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M7.81 12.747H0v7.545h7.81l.924-3.772zM16.19 12.747l-.76 3.773.76 3.772H24v-7.545z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M16.19 20.292v-3.07l-.47-.702.47-.703v-3.07H12l-.469 3.773.469 3.772z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M7.81 20.292H12v-7.545H7.81v3.07l.47.523-.47.883z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.19 15.817H12l-.465.703.465.703h4.19z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.81 15.817H12v1.406H7.81z"
  })));
};
export default SvgLivingRom;